import React from "react";

import { Box, Paper, Typography, colors, makeStyles } from "@material-ui/core";
import { formatCurrency, formatDateShort } from "@ds-developer/frontend";
import Button from "@ds-developer/button";
import Modal from "@ds-developer/modal";

import MaterialTable, { MTableBody } from "material-table";

import { Arrears } from "@hubcapp/types";

const useStyles = makeStyles(() => ({
  subtitle: {
    lineHeight: "1.6",
    color: colors.blueGrey[600],
  },
}));

type ArrearsBreakdownModalProps = {
  handleCancel: () => void;
  data: Arrears[];
  modalDisplay: boolean;
};

const ArrearsBreakdownModal: React.FC<ArrearsBreakdownModalProps> = ({
  handleCancel,
  data,
  modalDisplay,
}) => {
  const classes = useStyles();

  const actions = (
    <>
      <Button
        color="primary"
        data-test="arrears-breakdown-modal-close-button"
        disableElevation
        onClick={() => handleCancel()}
        variant="contained"
      >
        Close
      </Button>
    </>
  );

  return (
    (data && (
      <Modal
        actions={actions}
        open={modalDisplay}
        title={"Breakdown of arrears"}
      >
        <Box data-test="arrears-breakdown-modal">
          <Box mt={1} ml={2} mr={2}>
            <Typography variant="body2" className={classes.subtitle}>
              Debt type
            </Typography>
            <Typography variant="h2">
              {data[0].id ? data[0].reference : "Miscellaneous"}
            </Typography>
          </Box>
          {data[0].id && (
            <Box mt={1} ml={2} mr={2}>
              <Typography variant="body2" className={classes.subtitle}>
                Weeks in debt
              </Typography>
              <Typography variant="h2">{data.length}</Typography>
            </Box>
          )}
          <Box mt={1} ml={2} mr={2}>
            <MaterialTable
              data={data}
              options={{
                paging: false,
                emptyRowsWhenPaging: false,
                draggable: false,
                actionsColumnIndex: -1,
              }}
              components={{
                Toolbar: () => <></>,
                Container: props => <Paper {...props} elevation={0} />,
                Body: props => (
                  <>
                    <MTableBody {...props} />
                  </>
                ),
              }}
              columns={[
                {
                  title: "Date",
                  field: "date",
                  render: rowData => formatDateShort(new Date(rowData.date)),
                  sorting: false,
                },
                {
                  title: "Reference",
                  field: "reference",
                  render: rowData => (!rowData.id ? rowData.reference : ""),
                  sorting: false,
                },
                {
                  title: "Amount due",
                  field: "amount",
                  render: rowData =>
                    formatCurrency(rowData.amount, false, {
                      displayDecimalValue: true,
                    }),
                  sorting: false,
                },
                {
                  // Column defined but hidden to make the property
                  // available elsewhere
                  title: "id",
                  field: "id",
                  hidden: true,
                },
              ]}
            />
          </Box>
        </Box>
      </Modal>
    )) || <></>
  );
};

export default ArrearsBreakdownModal;
